import { useAccessLevel } from '../../accessLevel/AccessLevelContext';
import { useObjectType } from './useObjectType';
import { usePropertyAccessLevelOverride } from './usePropertyAccessLevelOverride';
import { usePropertyDefinition } from './usePropertyDefinition';
export const usePropertyAccessLevel = () => {
  const objectType = useObjectType();
  const property = usePropertyDefinition();
  const accessLevelOverride = usePropertyAccessLevelOverride();
  const accessLevel = useAccessLevel({
    objectType,
    propertyName: property.name,
    accessLevelOverride
  });
  return accessLevel;
};